const STORAGE_KEY = "sidebar_feedback_submissions_v1";
const MAX_SUBMISSIONS_PER_HOUR = 3;
const WINDOW_MS = 60 * 60 * 1000;

type RateLimitStatus = {
  isBlocked: boolean;
  remainingMs: number;
};

function getStoredTimestamps(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item) => typeof item === "number");
  } catch {
    return [];
  }
}

function saveTimestamps(timestamps: number[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(timestamps));
}

function getRecentTimestamps(now: number): number[] {
  const timestamps = getStoredTimestamps();
  const recent = timestamps.filter((ts) => now - ts < WINDOW_MS);
  if (recent.length !== timestamps.length) {
    saveTimestamps(recent);
  }
  return recent;
}

export function getFeedbackRateLimitStatus(now = Date.now()): RateLimitStatus {
  const recent = getRecentTimestamps(now);
  if (recent.length < MAX_SUBMISSIONS_PER_HOUR) {
    return { isBlocked: false, remainingMs: 0 };
  }

  const oldest = Math.min(...recent);
  const remainingMs = Math.max(WINDOW_MS - (now - oldest), 0);
  return {
    isBlocked: remainingMs > 0,
    remainingMs,
  };
}

export function recordFeedbackSubmission(now = Date.now()): void {
  const recent = getRecentTimestamps(now);
  recent.push(now);
  saveTimestamps(recent);
}

export function formatRemainingTime(remainingMs: number): string {
  const totalSeconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes <= 0) {
    return `${seconds}s`;
  }
  return `${minutes}m ${seconds}s`;
}
